import i18n from "../../utilities/i18n";
export const MAX_DISPLAY_NAME_LENGTH = 30
export const MAX_REMARKS_LENGTH = 20
export const maxValue = 999.99;
export const wholeNumberPattern = /^\d*$/;
export const maxChar = 120;

export const printConfigurationHeaders = [
    i18n.t("systemConfigs.printConfiguration.display_name"),
    i18n.t("systemConfigs.printConfiguration.x_position"),
    i18n.t("systemConfigs.printConfiguration.y_position"),
    i18n.t("systemConfigs.printConfiguration.max_char_len"),
    i18n.t("systemConfigs.printConfiguration.remarks"),
    i18n.t("systemConfigs.printConfiguration.action"),
]

export const headerTooltips = {
    "X Position": i18n.t("systemConfigs.tableTooltip.Xposition"),
    "Y Position": i18n.t("systemConfigs.tableTooltip.Yposition"),
    "Max Character Length": i18n.t("systemConfigs.tableTooltip.MaxCharacterLength")
  };

export const numericFields = [
    "x",
    "y",
    "repeat_y_gap",
    "repeat_count",
    "max_char_length",
];

export const decimalPattern = /^\d*(\.\d{0,2})?$/;


export const sectionMap = {
    1: i18n.t("systemConfigs.tableHeading.payerInfo"),
    2: i18n.t("systemConfigs.tableHeading.patientInfo"),
    3: i18n.t("systemConfigs.tableHeading.claimInfo"),
    4: i18n.t("systemConfigs.tableHeading.serviceInfo"),
    5: i18n.t("systemConfigs.tableHeading.providerInfo")
  };

export const printerErrorMap = {
    is_default_invalid: i18n.t("systemConfigs.errormessages.invalidValue"),
    name_max_length: i18n.t("systemConfigs.errormessages.lengthError"),
    name_required: i18n.t("systemConfigs.errormessages.nameRequired"),
    unique_printer_per_practice_violation: i18n.t("systemConfigs.errormessages.alreadyExist"),
  };

  export const marginErrorMap = {
    cms_1500_top_margin_must_be_a_valid_number: i18n.t("systemConfigs.errormessages.invalidTopMargin"),
    cms_1500_bottom_margin_must_be_a_valid_number: i18n.t("systemConfigs.errormessages.invalidBottomMargin"),
    cms_1500_left_margin_must_be_a_valid_number: i18n.t("systemConfigs.errormessages.invalidLeftMargin"),
    cms_1500_right_margin_must_be_a_valid_number: i18n.t("systemConfigs.errormessages.invalidRightMargin"),

    cms_1500_top_margin_must_be_positive: i18n.t("systemConfigs.errormessages.topMarginError"),
    cms_1500_bottom_margin_must_be_positive: i18n.t("systemConfigs.errormessages.bottomMarginError"),
    cms_1500_left_margin_must_be_positive: i18n.t("systemConfigs.errormessages.leftMarginError"),
    cms_1500_right_margin_must_be_positive: i18n.t("systemConfigs.errormessages.rightMarginError"),

    cms_1500_top_margin_must_be_less_than_or_equal_to_max_value: i18n.t("systemConfigs.errormessages.topMarginExceed"),
    cms_1500_bottom_margin_must_be_less_than_or_equal_to_max_value: i18n.t("systemConfigs.errormessages.bottomMarginExceed"),
    cms_1500_left_margin_must_be_less_than_or_equal_to_max_value: i18n.t("systemConfigs.errormessages.leftMarginExceed"),
    cms_1500_right_margin_must_be_less_than_or_equal_to_max_value: i18n.t("systemConfigs.errormessages.rightMarginExceed")
  };

  export const procedureError = {
    is_default_invalid: i18n.t("systemConfigs.errormessages.invalidValue"),
    name_max_length: i18n.t("systemConfigs.errormessages.lengthError"),
    name_required: i18n.t("systemConfigs.errormessages.nameRequired"),
    unique_printer_per_practice_violation: i18n.t("systemConfigs.errormessages.alreadyExist"),
  }

  export const ALL_HCFA_SECTIONS = [
    i18n.t("systemConfigs.tableHeading.payerInfo"),
    i18n.t("systemConfigs.tableHeading.patientInfo"),
    i18n.t("systemConfigs.tableHeading.claimInfo"),
    i18n.t("systemConfigs.tableHeading.serviceInfo"),
    i18n.t("systemConfigs.tableHeading.providerInfo")
];

/**
* Converts API response → form values (structured)
*/
export const structuredMargin = (data) => ({
  top: data.cms_1500_top_margin == 0 ? "0.00" : data.cms_1500_top_margin,
  bottom: data.cms_1500_bottom_margin == 0 ? "0.00" : data.cms_1500_bottom_margin,
  left: data.cms_1500_left_margin == 0 ? "0.00" : data.cms_1500_left_margin,
  right: data.cms_1500_right_margin == 0 ? "0.00" : data.cms_1500_right_margin,
});

/**
 * Converts form values → API payload
 */
export const mapMarginsToAPI = (formValue) => ({
  cms_1500_top_margin: Number(formValue.top),
  cms_1500_bottom_margin: Number(formValue.bottom),
  cms_1500_left_margin: Number(formValue.left),
  cms_1500_right_margin: Number(formValue.right),
});